export enum PortalCacheTagType {
  SalesViewI18n = 'SalesViewI18n',
  MetabaseToken = 'MetabaseToken',
}
